import BOption from './packages/BOption'

BOption.install = function(Vue) {
    Vue.component(BOption.name, BOption)
}

export default BOption
